import React from 'react';
import './MachinerySection.css';

import pro1 from '../../assets/Home/pro1.png';
import pro2 from '../../assets/Home/pro2.png';
import pro3 from '../../assets/Home/pro3.png';
import pro4 from '../../assets/Home/pro4.png';

const machineryData = [
  {
    id: 'panel-saw-3200-a',
    title: 'Panel Saw  3200 A++',
    description: 'An advanced panel cutting solution designed for high-performance woodworking, delivering accurate cuts, reliable operation, and efficient panel processing.',
    image: pro1,
    alt: 'Panel Saw 3200 A++'
  },  
  {
    id: 'six-sided-drilling',
    title: 'Six Sided Drilling – D 612 KS',
    description: 'Advanced six-sided panel processing with automated tool changes, precise positioning, and efficient double-board processing.',
    image: pro2,
    alt: 'Six Sided Drilling – D 612 KS'
  },
  {
    id: 'edge-bander',
    title: 'Edge Bander DEB 240S',
    description: 'Efficient automated edge banding with precise finishing for professional woodworking and cabinetry applications.',
    image: pro3,
    alt: 'Edge Bander DEB 240S'
  },
  {
    id: 'hydraulic-cold-press',
    title: 'Hydraulic Cold Press – DCP 1001',
    description: 'Heavy-duty hydraulic pressing for precise, consistent laminating and panel processing with reliable pressure control.',
    image: pro4,
    alt: 'Hydraulic Cold Press – DCP 1001'
  }
];

const MachinerySection = () => {
  return (
    <section className="machinery-section" id="machinery">
      <div className="machinery-container">
        
        {/* Left Column - Sticky Section Title & Description */}
        <div className="machinery-sticky-left">
          <span className="machinery-subtitle-tag">OUR MACHINERY</span>
          <h2 className="machinery-title">
            Industrial Machines Designed for Precision, Performance & Productivity
          </h2>
          <p className="machinery-description">
            Explore our comprehensive range of CNC and industrial machinery engineered to improve manufacturing efficiency, accuracy, and long-term reliability across multiple industries.
          </p>
        </div>

        {/* Right Column - Scrollable Stacked Machinery Cards */}
        <div className="machinery-cards-right">
          {machineryData.map((item) => (
            <div className="machinery-card" key={item.id}>
              
              {/* Card Left - Machinery Image */}
              <div className="machinery-card-image-wrap">
                <img 
                  src={item.image} 
                  alt={item.alt} 
                  className="machinery-card-img" 
                  loading="lazy" 
                />
              </div>

              {/* Card Right - Machinery Details & Arrow */}
              <div className="machinery-card-content">
                <div className="machinery-card-text">
                  <h3 className="machinery-card-title">{item.title}</h3>
                  <p className="machinery-card-desc">{item.description}</p>
                </div>

                <div className="machinery-card-action">
                  <button className="machinery-arrow-btn" aria-label={`Learn more about ${item.title}`}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                      <line x1="5" y1="12" x2="19" y2="12"></line>
                      <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                  </button>
                </div>
              </div>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default MachinerySection;